import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'

import PageHeader from '../../components/profile/pageHeader'
import WalletTabs from '../../components/profile/wallet/WalletTabs'
import usePageLoaded from '../../hooks/usePageLoaded'
import NotSentGift from '../../components/profile/wallet/notSentGift/NotSentGift'

import WalletDescription from '../../components/profile/wallet/WalletDescription'
import { fetchSavedGifts } from '../../store/member/memberSlice'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import './wallet.sass'
import PaginationWrapper from '../../components/pagination/paginationWrapper'
import { checkAuth, loadMember } from '../../utils/auth'
import paths from '../../paths'

const Wallet = () => {
    usePageLoaded()

    const [t] = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()

    const { user, savedGifts, savedGiftsTotal } = useSelector((state: RootState) => state.member)

    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        dispatch(fetchSavedGifts({ p: currentPage }))
    }, [currentPage])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.myWallet[getLangFromPath(location.pathname)].title}</title>
                <meta name="description" content={META.myWallet[getLangFromPath(location.pathname)].description} />
            </Helmet>
            <PageHeader user={user} text={t('My wallet')} self />
            <WalletTabs amountOfGifts={savedGiftsTotal || 0} />
            <WalletDescription />
            <div className={'walletProducts'}>
                {savedGifts.map((item) => (
                    // @ts-ignore
                    <NotSentGift
                        key={item.id}
                        giftInfo={item}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                ))}
            </div>
            {savedGiftsTotal > 20 && (
                <PaginationWrapper
                    limit={20}
                    limitOptions={20}
                    maxButtons={5}
                    activePage={currentPage}
                    onchange={(page: number) => {
                        setCurrentPage(page)
                    }}
                    total={Number(savedGiftsTotal)}
                />
            )}
        </div>
    )
}

//@ts-ignore
Wallet.getInitialProps = async ({ req, store }) => {
    if (req) {
        await checkAuth(store)
        const {
            member: { loggedIn }
        } = store.getState()

        if (loggedIn) {
            await loadMember(store)
        } else {
            return {
                redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.myWallet.path}`
            }
        }
    }
}

export default Wallet
